import { c as _c } from "react/compiler-runtime";
import { Icon, IconNames } from '@components/icon';
import { Page } from '@components/page';
import { getPaginationUlStylesAsClassName, getPaginationLiStylesAsClassName } from './pagination-styles';
export interface IPaginationProps {
  /** The total number of pages */
  totalPages: number;
  /** Current page to start */
  currentPage?: number;
  /** Total number of pages the Pagination will show in screen */
  boundaryPagesToShow?: number;
  /** Number of pages to the left and right of the current page */
  siblingCount?: number;
  /** Aria label for the nav element */
  navAriaLabel?: string;
  /** Aria label for all pages, should be something like "Go to page" as the component will add the page number after the text */
  pagesAriaLabel?: string;
  /** Function to be executed when the page changes */
  onPageChange: (page: number) => void;
}
export const Pagination = t0 => {
  const $ = _c(73);
  const {
    totalPages,
    currentPage,
    boundaryPagesToShow: t1,
    siblingCount: t2,
    navAriaLabel: t3,
    pagesAriaLabel: t4,
    onPageChange
  } = t0;
  const boundaryPagesToShow = t1 === undefined ? 7 : t1;
  const siblingCount = t2 === undefined ? 2 : t2;
  const navAriaLabel = t3 === undefined ? "Pagination" : t3;
  const pagesAriaLabel = t4 === undefined ? "Go to page" : t4;
  const dotsAllowed = totalPages - boundaryPagesToShow >= siblingCount;
  let t5;
  if ($[0] !== totalPages) {
    t5 = Array.from(Array(totalPages).keys()).map(_temp);
    $[0] = totalPages;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const pages = t5;
  const selectedPage = currentPage ?? pages[0] ?? 0;
  let t6;
  if ($[2] !== onPageChange) {
    t6 = page_0 => {
      onPageChange(page_0);
    };
    $[2] = onPageChange;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const onPageClick = t6;
  let t7;
  if ($[4] !== boundaryPagesToShow || $[5] !== selectedPage || $[6] !== siblingCount) {
    t7 = page_1 => {
      const firstPagesBeforeDots = boundaryPagesToShow - siblingCount;
      return selectedPage <= firstPagesBeforeDots && page_1 <= boundaryPagesToShow;
    };
    $[4] = boundaryPagesToShow;
    $[5] = selectedPage;
    $[6] = siblingCount;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const isPageBeforeDots = t7;
  let t8;
  if ($[8] !== boundaryPagesToShow || $[9] !== selectedPage || $[10] !== siblingCount || $[11] !== totalPages) {
    t8 = page_2 => {
      const lastPages = totalPages - boundaryPagesToShow;
      const lastPagesAfterDots = lastPages + siblingCount;
      return selectedPage > lastPagesAfterDots && page_2 > lastPages;
    };
    $[8] = boundaryPagesToShow;
    $[9] = selectedPage;
    $[10] = siblingCount;
    $[11] = totalPages;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const isPageAfterDots = t8;
  let t9;
  if ($[13] !== isPageAfterDots || $[14] !== isPageBeforeDots || $[15] !== selectedPage || $[16] !== siblingCount || $[17] !== totalPages) {
    t9 = page_3 => {
      const isFirstPage = page_3 === 1;
      const isLastPage = page_3 === totalPages;
      const inPagesBefore = page_3 >= selectedPage - siblingCount;
      const inPagesAfter = page_3 <= selectedPage + siblingCount;
      const inMiddlePages = inPagesBefore && inPagesAfter && !isPageBeforeDots(selectedPage) && !isPageAfterDots(selectedPage);
      return !isFirstPage && !isLastPage && (isPageBeforeDots(page_3) || isPageAfterDots(page_3) || inMiddlePages);
    };
    $[13] = isPageAfterDots;
    $[14] = isPageBeforeDots;
    $[15] = selectedPage;
    $[16] = siblingCount;
    $[17] = totalPages;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const canRenderPage = t9;
  let t10;
  if ($[19] !== canRenderPage || $[20] !== pages) {
    t10 = pages.filter(canRenderPage);
    $[19] = canRenderPage;
    $[20] = pages;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const pagesToRender = t10;
  const t11 = selectedPage === 1;
  let t12;
  if ($[22] !== onPageClick || $[23] !== selectedPage) {
    t12 = () => onPageClick(selectedPage - 1);
    $[22] = onPageClick;
    $[23] = selectedPage;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = selectedPage > 1 ? `${pagesAriaLabel} ${selectedPage - 1}` : undefined;
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon className="text-primary-main" name={IconNames.CHEVRON_LEFT} />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t15 = <li key="prev-page" className={getPaginationLiStylesAsClassName}><Page withIcon={true} disabled={t11} onClick={t12} ariaLabel={t13}>{t14}</Page></li>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== onPageClick) {
    t16 = () => onPageClick(1);
    $[30] = onPageClick;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const t17 = selectedPage === 1;
  const t18 = selectedPage > 1 ? `${pagesAriaLabel} 1` : undefined;
  let t19;
  if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
    t19 = <li key="page-1" className={getPaginationLiStylesAsClassName}><Page onClick={t16} selected={t17} ariaLabel={t18}>1</Page></li>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== dotsAllowed || $[37] !== isPageBeforeDots || $[38] !== selectedPage) {
    t20 = !isPageBeforeDots(selectedPage) && dotsAllowed && <li key="page-dots-1" className={getPaginationLiStylesAsClassName}><Page selectable={false}>...</Page></li>;
    $[36] = dotsAllowed;
    $[37] = isPageBeforeDots;
    $[38] = selectedPage;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== onPageClick || $[41] !== pagesAriaLabel || $[42] !== pagesToRender || $[43] !== selectedPage) {
    t21 = pagesToRender.map(page_4 => <li key={`page-${page_4}`} className={getPaginationLiStylesAsClassName}><Page selected={selectedPage === page_4} onClick={() => onPageClick(page_4)} ariaLabel={page_4 !== selectedPage ? `${pagesAriaLabel} ${page_4}` : undefined}>{page_4}</Page></li>);
    $[40] = onPageClick;
    $[41] = pagesAriaLabel;
    $[42] = pagesToRender;
    $[43] = selectedPage;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== dotsAllowed || $[46] !== isPageAfterDots || $[47] !== selectedPage) {
    t22 = !isPageAfterDots(selectedPage) && dotsAllowed && <li key="page-dots-2" className={getPaginationLiStylesAsClassName}><Page selectable={false}>...</Page></li>;
    $[45] = dotsAllowed;
    $[46] = isPageAfterDots;
    $[47] = selectedPage;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== onPageClick || $[50] !== pagesAriaLabel || $[51] !== selectedPage || $[52] !== totalPages) {
    t23 = totalPages > 1 && <li key={`page-${totalPages}`} className={getPaginationLiStylesAsClassName}><Page ariaLabel={`${pagesAriaLabel} ${totalPages}`} selected={selectedPage === totalPages} onClick={() => onPageClick(totalPages)}>{totalPages}</Page></li>;
    $[49] = onPageClick;
    $[50] = pagesAriaLabel;
    $[51] = selectedPage;
    $[52] = totalPages;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  const t24 = totalPages === selectedPage;
  let t25;
  if ($[54] !== onPageClick || $[55] !== selectedPage) {
    t25 = () => onPageClick(selectedPage + 1);
    $[54] = onPageClick;
    $[55] = selectedPage;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  const t26 = selectedPage < totalPages ? `${pagesAriaLabel} ${selectedPage + 1}` : undefined;
  let t27;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Icon className="text-primary-main" name={IconNames.CHEVRON_RIGHT} />;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t24 || $[59] !== t25 || $[60] !== t26) {
    t28 = <li key="next-page" className={getPaginationLiStylesAsClassName}><Page withIcon={true} disabled={t24} onClick={t25} ariaLabel={t26}>{t27}</Page></li>;
    $[58] = t24;
    $[59] = t25;
    $[60] = t26;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t15 || $[63] !== t19 || $[64] !== t20 || $[65] !== t21 || $[66] !== t22 || $[67] !== t23 || $[68] !== t28) {
    t29 = <ol className={getPaginationUlStylesAsClassName}>{t15}{t19}{t20}{t21}{t22}{t23}{t28}</ol>;
    $[62] = t15;
    $[63] = t19;
    $[64] = t20;
    $[65] = t21;
    $[66] = t22;
    $[67] = t23;
    $[68] = t28;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== navAriaLabel || $[71] !== t29) {
    t30 = <nav aria-label={navAriaLabel}>{t29}</nav>;
    $[70] = navAriaLabel;
    $[71] = t29;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  return t30;
};
function _temp(page) {
  return page + 1;
}